/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { numericDependencies } from './dependenciesNumeric.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMin } from '../../factoriesAny.js';
export var minDependencies = {
  numericDependencies,
  smallerDependencies,
  typedDependencies,
  createMin
};